import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigService } from './config.service';

@Injectable()
export class FeeUploadService {
  constructor(private http: HttpClient, private configService: ConfigService) {}

  getPendingFeeUploadsByBrokerHouse(brokerHouse: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getPendingFeeUploads`;
    return this.http.get(`${REST_URL}?brokerHouse=${brokerHouse}`);
  }

  getHistoryFeeUploadsByBrokerHouse(brokerHouse: string): Observable<any> {
    const REST_URL = `${this.baseUrl()}/getHistoryFeeUploads`;
    return this.http.get(`${REST_URL}?brokerHouse=${brokerHouse}`);
  }

  saveFeeUpload(data: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/saveFeeUpload`;
    return this.http.post(REST_URL, data);
  }

  downloadFile(data: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/downloadFile`;
    return this.http.post(REST_URL, { file: data });
  }

  deleteFeeUpload(uploadId: string, file: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/deleteFeeUpload`;
    return this.http.post(REST_URL, { uploadId, file });
  }

  uploadFile(formData: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/uploadFile`;
    return this.http.post(REST_URL, formData);
  }

  approveFeeUpload(data: any): Observable<any> {
    const REST_URL = `${this.baseUrl()}/approveFeeUpload`;
    return this.http.post(REST_URL, data);
  }

  private baseUrl(): string {
    return `${this.configService.apiUrl()}/feeUpload`;
  }
}
